const rngFrom = (seed) => {
  let s = 0;
  for (const ch of seed || "x") s = (s * 31 + ch.charCodeAt(0)) % 99991;
  return () => ((s = (s * 1103515245 + 12345) % 2147483648) / 2147483648);
};

const drawStarfield = (c, w, h, rand) => {
  c.fillStyle = "#060a14";
  c.fillRect(0, 0, w, h);
  for (let i = 0; i < 220; i++) {
    const x = rand() * w, y = rand() * h, r = rand() * 1.2;
    c.globalAlpha = 0.25 + rand() * 0.55;
    c.fillStyle = rand() > 0.85 ? "#f5d061" : "#ffffff";
    c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fill();
  }
  c.globalAlpha = 1;
  c.strokeStyle = "rgba(212,175,55,0.12)";
  c.lineWidth = 1;
  for (let i = 1; i < 8; i++) {
    c.beginPath(); c.moveTo((w / 8) * i, 0); c.lineTo((w / 8) * i, h); c.stroke();
    c.beginPath(); c.moveTo(0, (h / 8) * i); c.lineTo(w, (h / 8) * i); c.stroke();
  }
};

const drawMoon = (c, w, h, co, rand) => {
  const R = Math.min(w, h) * 0.36, cx = w / 2, cy = h / 2;
  const g = c.createRadialGradient(cx - R * 0.3, cy - R * 0.3, R * 0.1, cx, cy, R);
  g.addColorStop(0, "#dfe4ec"); g.addColorStop(1, "#7d8494");
  c.fillStyle = g;
  c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fill();
  c.fillStyle = "rgba(70,76,90,0.55)";
  for (let i = 0; i < 22; i++) {
    const a = rand() * Math.PI * 2, d = rand() * R * 0.85, cr = 2 + rand() * 10;
    c.beginPath(); c.arc(cx + Math.cos(a) * d, cy + Math.sin(a) * d, cr, 0, Math.PI * 2); c.fill();
  }
  return [cx + ((co.longitude || 0) / 90) * R * 0.9, cy - ((co.latitude || 0) / 90) * R * 0.9];
};

const drawConstellation = (c, w, h, co) => {
  const px = ((co.ra_hours || 0) / 24) * w * 0.9 + w * 0.05;
  const py = h / 2 - ((co.declination || 0) / 90) * (h * 0.42);
  c.strokeStyle = "rgba(245,208,97,0.35)";
  c.beginPath();
  c.moveTo(px - 60, py + 42); c.lineTo(px, py); c.lineTo(px + 52, py - 36); c.lineTo(px + 96, py + 12);
  c.stroke();
  return [px, py];
};

const drawMarker = (c, px, py) => {
  c.strokeStyle = "#f5d061";
  c.lineWidth = 1.4;
  c.beginPath(); c.arc(px, py, 14, 0, Math.PI * 2); c.stroke();
  c.beginPath(); c.arc(px, py, 22, 0, Math.PI * 2);
  c.strokeStyle = "rgba(245,208,97,0.35)"; c.stroke();
  c.beginPath();
  c.moveTo(px - 30, py); c.lineTo(px - 18, py);
  c.moveTo(px + 18, py); c.lineTo(px + 30, py);
  c.moveTo(px, py - 30); c.lineTo(px, py - 18);
  c.moveTo(px, py + 18); c.lineTo(px, py + 30);
  c.stroke();
  const gg = c.createRadialGradient(px, py, 0, px, py, 12);
  gg.addColorStop(0, "#fff8e1"); gg.addColorStop(1, "rgba(245,208,97,0)");
  c.fillStyle = gg;
  c.beginPath(); c.arc(px, py, 12, 0, Math.PI * 2); c.fill();
};

// Renders the 2D celestial position of a registry record onto a canvas.
export const paintCelestialMap = (canvas, record, height) => {
  const dpr = window.devicePixelRatio || 1;
  const w = canvas.clientWidth;
  canvas.width = w * dpr;
  canvas.height = height * dpr;
  const c = canvas.getContext("2d");
  c.scale(dpr, dpr);

  const rand = rngFrom(record.registry_id);
  drawStarfield(c, w, height, rand);

  const isMoon = record.registry_type === "MOON";
  const co = record.coordinates || {};
  const [px, py] = isMoon ? drawMoon(c, w, height, co, rand) : drawConstellation(c, w, height, co);
  drawMarker(c, px, py);

  c.font = "11px 'JetBrains Mono', monospace";
  c.fillStyle = "rgba(245,208,97,0.9)";
  c.fillText(record.location_display || "", 14, height - 14);
  c.fillStyle = "rgba(148,163,184,0.85)";
  c.fillText(isMoon ? "SELENOGRAPHIC / ME FRAME" : "ICRS · J2000.0", 14, 20);
};
